module.exports = __webpack_public_path__ + "img/clouds-sun.8920b88e.svg";